/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import Styles from '../../css/LoanInformation.module.css';
import EnvelopeWithBox from '../EnvelopeWithBox';

function ARMSettingsSkeleton() {
  return (
    <EnvelopeWithBox blockName='&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'>
      <span className={Styles.loanInfoTable}>
        <table className={Styles.loanInfoTableSection}>
          <tbody>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td></td>
            </tr>
          </tbody>
        </table>
      </span>
    </EnvelopeWithBox>
  );
}

export default ARMSettingsSkeleton;
